module.exports = __webpack_public_path__ + "img/banner.3ec5d456.png";